<template>
  <div>
    <div id="Schedule">
      <b-container fluid class="scheduleMain">
        <b-row>
          <b-col>
            <h1>2024 Schedule</h1>
            <div class="line"></div>
          </b-col>
        </b-row>

        <div class="scheduleWrapper">
          <div class="schedule-item" v-for="(month, i) in calendar" :key="i">
            <div class="calendar">
              <div class="calendar-month">{{ month.name }}</div>
              <div class="calendar-row clearfix">
                <span class="calendar-day-head">Sun</span>
                <span class="calendar-day-head">Mon</span>
                <span class="calendar-day-head">Tue</span>
                <span class="calendar-day-head">Wed</span>
                <span class="calendar-day-head">Thu</span>
                <span class="calendar-day-head">Fri</span>
                <span class="calendar-day-head">Sat</span>
              </div>
              <span
                v-for="(day, o) in month.days"
                :key="o * 1000"
                class="calendar-day"
                :class="{
                  'dark-blue':
                    day.opponent &&
                    !day.opponent.includes('@') &&
                    !day.opponent.includes('ASG'),
                }"
              >
                <div v-if="day.allStar" class="allstarText">
                  <p>ALL-STAR BREAK</p>
                  <!-- <span>Los Angeles, CA</span> -->
                </div>
                <div class="day-number">{{ day.num }}</div>
                <p>
                  {{ day.opponent }} <span>{{ day.time }}</span>
                </p>
              </span>
            </div>
          </div>
        </div>

        <div class="legend">
          <div class="home"></div>
          <strong>Home</strong>
          <div class="away"></div>
          <strong>Away</strong>
          <span>(Schedule subject to change)</span>
        </div>
      </b-container>
    </div>
    <Banner bannerDivider="ninth" />
  </div>
</template>

<script>
import Banner from "@/components/sections/Banner/Banner";

export default {
  name: "Schedule",
  components: {
    Banner,
  },
  data() {
    return {
      calendar: [
      {
          name: "March • April",
          days: [
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "28", opponent: "TOR", time: "4:10 PM" },
            { num: "29", opponent: "TOR", time: "6:50 PM" },
            { num: "30", opponent: "TOR", time: "4:10 PM" },
            { num: "31", opponent: "TOR", time: "1:40 PM" },
            { num: "1", opponent: "TEX", time: "6:50 PM" },
            { num: "2", opponent: "TEX", time: "6:50 PM" },
            { num: "3", opponent: "TEX", time: "1:10 PM" },
            { num: "4", opponent: "" },
            { num: "5", opponent: "@COL" },
            { num: "6", opponent: "@COL" },
            { num: "7", opponent: "@COL" },
            { num: "8", opponent: "@LAA" },
            { num: "9", opponent: "@LAA" },
            { num: "10", opponent: "@LAA" },
            { num: "11", opponent: "" },
            { num: "12", opponent: "SF", time: "6:50 PM" },
            { num: "13", opponent: "SF", time: "4:10 PM" },
            { num: "14", opponent: "SF", time: "1:40 PM" },
            { num: "15", opponent: "LAA", time: "6:50 PM" },
            { num: "16", opponent: "LAA", time: "6:50 PM" },
            { num: "17", opponent: "LAA", time: "6:50 PM" },
            { num: "18", opponent: "LAA", time: "1:10 PM" },
            { num: "19", opponent: "@NYY" },
            { num: "20", opponent: "@NYY" },
            { num: "21", opponent: "@NYY" },
            { num: "22", opponent: "DET", time: "6:50 PM" },
            { num: "23", opponent: "DET", time: "6:50 PM" },
            { num: "24", opponent: "DET", time: "6:50 PM" },
            { num: "25", opponent: "" },
            { num: "26", opponent: "@CWS" },
            { num: "27", opponent: "@CWS" },
            { num: "28", opponent: "@CWS" },
            { num: "29", opponent: "@MIL" },
            { num: "30", opponent: "@MIL" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
          ],
        },
        {
          name: "May",
          days: [
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "1", opponent: "@MIL" },
            { num: "2", opponent: "" },
            { num: "3", opponent: "NYM", time: "6:50 PM" },
            { num: "4", opponent: "NYM", time: "7:15 PM" },
            { num: "5", opponent: "NYM", time: "1:40 PM" },
            { num: "6", opponent: "CWS", time: "6:50 PM" },
            { num: "7", opponent: "CWS", time: "6:50 PM" },
            { num: "8", opponent: "CWS", time: "6:50 PM" },
            { num: "9", opponent: "" },
            { num: "10", opponent: "NYY", time: "6:50 PM" },
            { num: "11", opponent: "NYY", time: "4:10 PM" },
            { num: "12", opponent: "NYY", time: "1:40 PM" },
            { num: "13", opponent: "@BOS" },
            { num: "14", opponent: "@BOS" },
            { num: "15", opponent: "@BOS" },
            { num: "16", opponent: "@BOS" },
            { num: "17", opponent: "@TOR" },
            { num: "18", opponent: "@TOR" },
            { num: "19", opponent: "@TOR" },
            { num: "20", opponent: "BOS", time: "6:50 PM" },
            { num: "21", opponent: "BOS", time: "6:50 PM" },
            { num: "22", opponent: "BOS", time: "6:50 PM" },
            { num: "23", opponent: "" },
            { num: "24", opponent: "KC", time: "6:50 PM" },
            { num: "25", opponent: "KC", time: "4:10 PM" },
            { num: "26", opponent: "KC", time: "1:40 PM" },
            { num: "27", opponent: "" },
            { num: "28", opponent: "OAK", time: "6:50 PM" },
            { num: "29", opponent: "OAK", time: "6:50 PM" },
            { num: "30", opponent: "OAK", time: "1:10 PM" },
            { num: "31", opponent: "@BAL" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
          ],
        },
        {
          name: "JUNE",
          days: [
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "1", opponent: "@BAL" },
            { num: "2", opponent: "@BAL" },
            { num: "3", opponent: "" },
            { num: "4", opponent: "@MIA" },
            { num: "5", opponent: "@MIA" },
            { num: "6", opponent: "" },
            { num: "7", opponent: "BAL", time: "6:50 PM" },
            { num: "8", opponent: "BAL", time: "4:10 PM" },
            { num: "9", opponent: "BAL", time: "1:40 PM" },
            { num: "10", opponent: "BAL", time: "6:50 PM" },
            { num: "11", opponent: "CHC", time: "6:50 PM" },
            { num: "12", opponent: "CHC", time: "6:50 PM" },
            { num: "13", opponent: "CHC", time: "6:50 PM" },
            { num: "14", opponent: "@ATL" },
            { num: "15", opponent: "@ATL" },
            { num: "16", opponent: "@ATL" },
            { num: "17", opponent: "" },
            { num: "18", opponent: "@MIN" },
            { num: "19", opponent: "@MIN" },
            { num: "20", opponent: "@MIN" },
            { num: "21", opponent: "@PIT" },
            { num: "22", opponent: "@PIT" },
            { num: "23", opponent: "@PIT" },
            { num: "24", opponent: "SEA", time: "6:50 PM" },
            { num: "25", opponent: "SEA", time: "6:50 PM" },
            { num: "26", opponent: "SEA", time: "12:10 PM" },
            { num: "27", opponent: "" },
            { num: "28", opponent: "WSH", time: "6:50 PM" },
            { num: "29", opponent: "WSH", time: "4:10 PM" },
            { num: "30", opponent: "WSH", time: "1:40 PM" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
          ],
        },
        {
          name: "JULY",
          days: [
            { num: "", opponent: "" },
            { num: "1", opponent: "" },
            { num: "2", opponent: "@KC" },
            { num: "3", opponent: "@KC" },
            { num: "4", opponent: "@KC" },
            { num: "5", opponent: "@TEX" },
            { num: "6", opponent: "@TEX" },
            { num: "7", opponent: "@TEX" },
            { num: "8", opponent: "" },
            { num: "9", opponent: "NYY", time: "6:50 PM" },
            { num: "10", opponent: "NYY", time: "6:50 PM" },
            { num: "11", opponent: "NYY", time: "6:50 PM" },
            { num: "12", opponent: "CLE", time: "6:50 PM" },
            { num: "13", opponent: "CLE", time: "4:10 PM" },
            { num: "14", opponent: "CLE", time: "1:40 PM"},
            { num: "15", opponent: "" },
            { num: "16", opponent: "" , allStar: true },
            { num: "17", opponent: "" },
            { num: "18", opponent: "" },
            { num: "19", opponent: "@NYY" },
            { num: "20", opponent: "@NYY" },
            { num: "21", opponent: "@NYY" },
            { num: "22", opponent: "@NYY" },
            { num: "23", opponent: "@TOR" },
            { num: "24", opponent: "@TOR" },
            { num: "25", opponent: "@TOR" },
            { num: "26", opponent: "CIN", time: "6:50 PM" },
            { num: "27", opponent: "CIN", time: "4:10 PM" },
            { num: "28", opponent: "CIN", time: "1:40 PM" },
            { num: "29", opponent: "" },
            { num: "30", opponent: "MIA", time: "6:50 PM" },
            { num: "31", opponent: "MIA", time: "12:10 PM" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
          ],
        },
        {
          name: "August",
          days: [
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "1", opponent: "" },
            { num: "2", opponent: "@HOU" },
            { num: "3", opponent: "@HOU" },
            { num: "4", opponent: "@HOU" },
            { num: "5", opponent: "" },
            { num: "6", opponent: "@STL" },
            { num: "7", opponent: "@STL" },
            { num: "8", opponent: "@STL" },
            { num: "9", opponent: "BAL", time: "6:50 PM" },
            { num: "10", opponent: "BAL", time: "7:15 PM" },
            { num: "11", opponent: "BAL", time: "1:40 PM" },
            { num: "12", opponent: "HOU", time: "6:50 PM" },
            { num: "13", opponent: "HOU", time: "6:50 PM" },
            { num: "14", opponent: "HOU", time: "6:50 PM" },
            { num: "15", opponent: "" },
            { num: "16", opponent: "AZ", time: "6:50 PM" },
            { num: "17", opponent: "AZ", time: "4:10 PM" },
            { num: "18", opponent: "AZ", time: "1:40 PM" },
            { num: "19", opponent: "@OAK" },
            { num: "20", opponent: "@OAK" },
            { num: "21", opponent: "@OAK" },
            { num: "22", opponent: "@OAK" },
            { num: "23", opponent: "@LAD" },
            { num: "24", opponent: "@LAD" },
            { num: "25", opponent: "@LAD" },
            { num: "26", opponent: "@SEA" },
            { num: "27", opponent: "@SEA" },
            { num: "28", opponent: "@SEA" },
            { num: "29", opponent: "" },
            { num: "30", opponent: "SD", time: "6:50 PM" },
            { num: "31", opponent: "SD", time: "4:10 PM" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
          ],
        },
        {
          name: "September • October",
          days: [
            { num: "1", opponent: "SD", time: "1:40 PM" },
            { num: "2", opponent: "MIN", time: "6:50 PM" },
            { num: "3", opponent: "MIN", time: "6:50 PM" },
            { num: "4", opponent: "MIN", time: "6:50 PM" },
            { num: "5", opponent: "MIN", time: "1:10 PM" },
            { num: "6", opponent: "@BAL" },
            { num: "7", opponent: "@BAL" },
            { num: "8", opponent: "@BAL" },
            { num: "9", opponent: "@PHI" },
            { num: "10", opponent: "@PHI" },
            { num: "11", opponent: "@PHI" },
            { num: "12", opponent: "@CLE" },
            { num: "13", opponent: "@CLE" },
            { num: "14", opponent: "@CLE" },
            { num: "15", opponent: "@CLE" },
            { num: "16", opponent: "" },
            { num: "17", opponent: "BOS", time: "6:50 PM" },
            { num: "18", opponent: "BOS", time: "6:50 PM" },
            { num: "19", opponent: "BOS", time: "6:50 PM" },
            { num: "20", opponent: "TOR", time: "6:50 PM" },
            { num: "21", opponent: "TOR", time: "4:10 PM" },
            { num: "22", opponent: "TOR", time: "1:40 PM" },
            { num: "23", opponent: "" },
            { num: "24", opponent: "@DET" },
            { num: "25", opponent: "@DET" },
            { num: "26", opponent: "@DET" },
            { num: "27", opponent: "@BOS" },
            { num: "28", opponent: "@BOS" },
            { num: "29", opponent: "@BOS" },
            { num: "30", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
            { num: "", opponent: "" },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
#Schedule {
  padding-block: 150px 100px;
  background-image: url("~@/assets/images/bgImage_babyblue.jpg");
  background-size: cover;
  .scheduleMain {
    padding: 0 7%;
    @media only screen and (max-width: $sm) {
      zoom: 0.9;
    }
    .line {
      background-color: $yellow;
      width: 298px;
      height: 5px;
      margin: 15px 0 1em;
    }
    h1 {
      font-family: "Antique Olive";
      font-style: normal;
      /* text-align: center; */
      font-weight: 700;
      font-size: 35px;
      line-height: 80%;
      text-transform: uppercase;
      color: #00285e;

      @media only screen and (max-width: $sm) {
        font-size: 25px;
      }
    }
    .scheduleWrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      /* min-width: 100%; */
      /* width: calc(100% + 20px); */
      justify-content: center;
      /* margin-left: -10px; */
      margin: 30px auto;
      gap: 10px;
      max-width: 1500px;
      .calendar {
        width: 100%;
        min-width: 400px;
        height: auto;
        overflow: hidden;
        background: $light-blue;
        color: white;
        border-left: 1px solid $light-blue;
        border-right: 1px solid $light-blue;
        border-bottom: 1px solid $light-blue;
        .allstarText {
          position: absolute;
          width: 225px;
          z-index: 2;
          color: $dark-blue;
          text-align: center;
          /* margin: 15px 0 0 14px; */
          font-family: "Futura";
          font-size: 14px;
          line-height: 14px;
        }
      }
      .calendar .calendar-month {
        text-align: left;
        padding: 5px 5px 5px 10px;
        font-size: 25px;
        text-transform: uppercase;
        font-family: "Futura";
      }
      .calendar .calendar-day-head {
        width: calc(100% / 7);
        display: block;
        float: left;
        text-align: center;
        font-size: 12px;
        text-transform: uppercase;
        font-family: "Futura";
      }
      .calendar .calendar-day-np,
      .calendar .calendar-day {
        position: relative;
        width: calc(100% / 7);
        display: block;
        float: left;
        height: 50px;
        background: white;
        color: #000000;
        border: 1px solid #79bde7;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -ms-transition: all 1s ease;
        transition: all 1s ease;
        &.dark-blue {
          background: $dark-blue;
          color: #fff;
          p {
            color: #fff;
            span {
              color: #fff;
            }
          }
        }
      }
      .calendar .calendar-row {
        position: relative;
        overflow: hidden;
      }
      .calendar .calendar-day.small {
        height: 24px;
        &.abs-left {
          position: absolute;
          left: 0;
          top: 25px;
        }
        &.abs-left2 {
          position: absolute;
          top: 25px;
          left: calc(100% / 7);
          width: calc(100% / 7);
        }
        &.abs-left3 {
          position: absolute;
          top: 25px;
          left: calc(100% / 7);
          width: calc(100% / 7);
          margin-left: calc(100% / 7);
        }
        &.abs-left4 {
          position: absolute;
          top: 25px;
          left: calc(100% / 7);
          width: calc(100% / 7);
          margin-left: calc((100% / 7) + 14.2857143%);
        }
        &.abs-left5 {
          position: absolute;
          top: 25px;
          left: calc(100% / 7);
          width: calc(100% / 7);
          margin-left: calc((100% / 7) + 28.5714286%);
        }
        p {
          padding: 5px 0;
          font-size: 12px;
          line-height: 12px;
          margin: 0;
          margin-left: 5px;
          span {
            display: block;
            margin-top: -4px;
            font-size: 8px;
          }
        }
      }
      .calendar .calendar-day .day-number {
        position: absolute;
        font-size: 8px;
        top: 2px;
        left: 2px;
        font-family: "Futura";
      }
      .calendar .calendar-day p {
        margin: 0;
        padding: 17px 0;
        font-size: 13px;
        display: block;
        text-align: center;
        line-height: 1;
        color: #00285e;
        font-family: "Futura";
        font-weight: 900;
        span {
          font-weight: 400;
          display: block;
          font-size: 10px;
          margin-top: 3px;
          color: #00285e;
        }
      }
      .calendar .calendar-day.active {
        background: #002d62;
        .day-number,
        p {
          color: #fff;
          span {
            color: #fff;
          }
        }
      }
      .calendar .calendar-day.active .day-number,
      .calendar .calendar-day.active p {
        color: white;
      }
      .schedule-item {
        width: 410px;
        /* width: calc(33.33% - 21px); */
        /* margin: 10px; */
        @media only screen and (max-width: $lg) {
          /* width: calc(50% - 21px); */
        }
        @media only screen and (max-width: $md) {
          /* width: calc(100% - 21px); */
        }
      }
    }
    .legend {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      @media only screen and (max-width: $sm) {
        flex-direction: column;
      }
      .home {
        height: 30px;
        width: 30px;
        background-color: #002d62;
        border: 1px solid #fff;
        margin-right: 10px;
        @media only screen and (max-width: $sm) {
          height: 20px;
          width: 20px;
        }
      }
      .away {
        height: 30px;
        width: 30px;
        margin-right: 10px;
        background-color: #fff;
        border: 1px solid $dark-blue;
        @media only screen and (max-width: $sm) {
          height: 20px;
          width: 20px;
        }
      }
      strong {
        font-size: 16px;
        color: $dark-blue;
        letter-spacing: 0;
        line-height: 24px;
        margin-right: 20px;
        font-weight: 800;
      }
      span {
        font-size: 16px;
        color: $dark-blue;
        letter-spacing: 0;
        line-height: 24px;
      }
    }
  }
}
</style>
